import { NavLink } from "react-router-dom";
import { Home, Wrench, CalendarCheck, Wallet, UserCircle } from "lucide-react";

const TABS = [
  { label: "Home", to: "/", icon: Home },
  { label: "Services", to: "/services", icon: Wrench },
  { label: "Bookings", to: "/bookings", icon: CalendarCheck },
  { label: "Wallet", to: "/wallet", icon: Wallet },
  { label: "Profile", to: "/profile", icon: UserCircle },
];

export default function MobileTabBar() {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-800 z-50 safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {TABS.map(({ label, to, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 text-xs font-medium transition-colors ${
                isActive
                  ? "text-primary-600 dark:text-primary-400"
                  : "text-neutral-400 dark:text-neutral-500"
              }`
            }
          >
            <Icon size={22} strokeWidth={1.8} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
